import { render } from "./ProductsForInterventionColumn.vue?vue&type=template&id=0ed9a130&scoped=true"
import script from "./ProductsForInterventionColumn.vue?vue&type=script&lang=js"
export * from "./ProductsForInterventionColumn.vue?vue&type=script&lang=js"

import "./ProductsForInterventionColumn.vue?vue&type=style&index=0&id=0ed9a130&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ed9a130"]])

export default __exports__